import { Button, styled } from '@mui/material';

export const PrimaryActionButton = styled(Button)(({ theme }) => ({
  borderRadius: 4,
  letterSpacing: 1,
  fontWeight: theme.typography.fontWeightMedium,
}));
